import { CSSProperties, ReactElement } from 'react'
import style from './loadingDots.module.css'

interface Props {
    className?: string
    size?: string | number
    color?: string
    duration?: string
    style?: CSSProperties
    dotElement?: ReactElement
}

/**
 * @deprecated Use @trustoo/components/ui/LoadingDots instead
 */
const LoadingDots = ({
    className,
    size,
    color,
    duration,
    style: inlineStyle,
    dotElement,
}: Props) => {
    const dotEl = dotElement || (
        <span
            style={{
                backgroundColor: color,
                animationDuration: duration,
            }}
        />
    )
    return (
        <span
            className={[style.root, className].join(' ')}
            style={{ fontSize: size, ...(inlineStyle || {}) }}>
            {dotEl}
            {dotEl}
            {dotEl}
        </span>
    )
}

export default LoadingDots
